import { RefObject, useEffect, useState } from 'react'

// A hero on a page merchants leave open all day should not keep animating out
// of view, so the loop is parked whenever the scene scrolls off screen.
const useIsOffscreen = (ref: RefObject<HTMLDivElement | null>) => {
  const [isOffscreen, setIsOffscreen] = useState(false)

  useEffect(() => {
    const element = ref.current

    if (!element || typeof IntersectionObserver === 'undefined') {
      return
    }

    const observer = new IntersectionObserver(entries => {
      const entry = entries[entries.length - 1]

      if (entry) {
        setIsOffscreen(!entry.isIntersecting)
      }
    })

    observer.observe(element)

    return () => observer.disconnect()
  }, [ref])

  return isOffscreen
}

export default useIsOffscreen
